"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryStore = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * {@inheritDoc ICategoryStore}
 */
class CategoryStore {
    constructor(categories = []) {
        this.categories = categories;
    }
    addCategory(category) {
        this.categories.push(category);
        return category;
    }
    toArray() {
        return this.categories;
    }
    removeCategory(category) {
        rc_js_util_1._Array.removeOne(this.categories, category);
    }
}
exports.CategoryStore = CategoryStore;
//# sourceMappingURL=category-store.js.map